/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6';

export const transform = transformObj => (obj, opts = {}) => {
  const transformed = Object.keys(obj).reduce((acc, key) => {
    const value = obj[key];
    const transformation = transformObj[key];

    if (!obj.hasOwnProperty(key)) {
      return acc;
    }

    if (typeof transformation === 'function') {
      const nextObj = Object.assign({}, acc);
      const transformedValue = transformation(value, nextObj);

      if (typeof transformedValue !== 'undefined') {
        nextObj[key] = transformedValue;
      }

      return nextObj;
    } // recursive portion
    //      if (typeof value === 'object' && value !== null) {
    //        return {
    //          ...acc,
    //          [key]: transform(transformObj, value)
    //        };
    //      }


    return Object.assign({}, acc, {
      [key]: value
    });
  }, {});

  if (transformObj.__constructor && opts.shouldConstruct) {
    return new transformObj.__constructor(transformed);
  } else {
    return transformed;
  }
}; // Transform Functions

export const construct = Type => {
  return obj => {
    return new Type(obj);
  };
};
export const listConstruct = (ListType, transformFn) => {
  return arr => {
    const list = arr.map(obj => {
      return transformFn(obj);
    });
    return new ListType(list);
  };
};